import { ButtonExperience } from './btn-experience';

/**
 *
 * using set-timeout and giving a delay of 1 sec so as to set some value of TTI and FMP for UFO metrics
 * @param name parameter for the name to be tracked by UFO experience
 */

export const ufoHandleButtonClick = (name: string) => {
  const buttonClicked = ButtonExperience(name);
  buttonClicked.start();
  setTimeout(() => buttonClicked.success(), 1000);
};

/**
 *
 * @param product parameter for any product name as AC or PPC
 * @param parentName parameter to get from what page of the product that button is clicked
 * @param buttonLabel parameter to get the label of button clicked
 */
export const ufoCommonButtonClickEvents = (product: string, parentName: string, buttonLabel: string) => {
  let parentPage = product + '-' + parentName;
  if (parentPage === product + '-') {
    parentPage = product + '-' + 'home-page';
  }
  const name = parentPage + '-' + buttonLabel?.toLowerCase().replace(/ /g, '-');
  ufoHandleButtonClick(name);
};

/**
 * @param parentPage main page where dropdown menu exists
 * @param button name of dropdown menu
 */
export const moreActionsDropdown = (parentPage: string, button: string) => {
  if (parentPage === 'ac') parentPage = 'ac-home-page';
  else {
    parentPage = 'ppc-home-page';
  }
  const name = parentPage + '-' + button;
  ufoHandleButtonClick(name);
};
